/**
 * Redefinition of the drawing of the rectangles to adapt it to our needs 
 * 
 * - bar chart stacked rounded at each end 
 * - for horizontal and vertical bar chart
 */
Chart.elements.Rectangle.prototype.draw = function(debug = false) {
    const ctx = this._chart.ctx;
    const vm  = this._view;
    let left, right, top, bottom;
    const typeOfChart = this._chart.config.type;

    // If radius is less than 0 or is large enough to cause drawing errors a max
    // radius is imposed. If cornerRadius is not defined set it to 0.
    let cornerRadius = this._chart.config.options.cornerRadius;
    if(cornerRadius < 0 || typeof cornerRadius == 'undefined') cornerRadius = 0;

    const isRoundedBar = !!this._chart.config.options.isRoundedBar;

    if (!vm.horizontal) {
        // bar
        left   = vm.x - vm.width / 2;
        right  = vm.x + vm.width / 2;
        top    = vm.y;
        bottom = vm.base;
    } else {
        // horizontal bar
        left   = vm.base;
        right  = vm.x;
        top    = vm.y - vm.height / 2;
        bottom = vm.y + vm.height / 2;
    }

    ctx.beginPath();
    ctx.fillStyle = vm.backgroundColor;

    // Corner points, from bottom-left to bottom-right clockwise
    // | 1 2 |
    // | 0 3 |
    var corners = [
        [left, bottom],
        [left, top],
        [right, top],
        [right, bottom]
    ];

    const originalWidth  = corners[2][0] - corners[1][0];
    const originalHeight = corners[0][1] - corners[1][1];

    const width   = !vm.horizontal && originalWidth > 24 ? 24 : originalWidth; // fix max width for correct display (vertical case)
    const offsetX = !vm.horizontal && originalWidth > 24 ? (originalWidth - width) / 2 : 0; // add offset width for correct centering

    const height  = vm.horizontal ? 24 : originalHeight; // fix max height for correct display (horizontal case)
    const offsetY = vm.horizontal ? (originalHeight - height) / 2 : 0; // add offset height for correct centering

    const x = corners[1][0] + offsetX;
    const y = corners[1][1] + offsetY;

    const radius = typeOfChart === 'horizontalBar' ? Math.floor(Math.abs(height)/2) : Math.floor(Math.abs(width)/2);

    // retrieve all visible data slice indexes
    // necessary to correctly redraw rounded bars when using filters 
    const countDatasets = this._chart.data.datasets.length;
    const visibleIndexes = [...Array(countDatasets).keys()]
        .map(i => this._chart.getDatasetMeta(i))
        .filter(meta => !meta.hidden && meta.controller && meta.controller._data[this._index] > 0)
        .map(meta => meta.controller.index)
    ;

    // calculate the last and first visible index
    const lastVisibleIndex  = Math.max(...visibleIndexes);

    if (isRoundedBar && this._datasetIndex === lastVisibleIndex) {
        // isRoundedBar && Last index visible
        // Draw with a radius only on the top of the rectangle

        // to top right (rounded corner)
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, radius > height ? y + height : y + radius);

        // to bottom right (rounded corner for horizontalBar else not)
        ctx.lineTo(x + width, y + height - radius);
        typeOfChart === 'horizontalBar'
            ? ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
            : ctx.lineTo(x + width, y + height);

        // to bottom left (angle corner)
        ctx.lineTo(x, y + height);
        
        // to top left (rounded corner for bar else not)
        ctx.lineTo(x, radius > height ? y + height : y + radius);
        typeOfChart == 'bar'
            ? ctx.quadraticCurveTo(x, y, x + radius, y)
            : ctx.lineTo(x, y);
    } else {
        // !isRoundedBar or Intermediate index
        // Draw the rectangle without radius
        ctx.rect(x, y, width, height);
    }

    ctx.fill();
};
